import { QuestionCircleOutlined } from '@ant-design/icons';
import { Modal, Select, Space, Tooltip, Typography } from 'antd';
import { IDespesaFullDTO } from '../../../../models/happy-code-api.model';
import BaseInput from '../../components/base-input';
import BaseSelect from '../../components/base-select';
import { Dispatch, SetStateAction, useState } from 'react';

interface ModalRepetirProps {
	isRecurrenceModalOpen: boolean;
	despesa: IDespesaFullDTO;
	setDespesa: Dispatch<SetStateAction<IDespesaFullDTO>>;
	setRecurrenceModalOpen: Dispatch<SetStateAction<boolean>>;
	setIsRecurring: Dispatch<SetStateAction<boolean>>;
}

export default function ModalRepetir({ isRecurrenceModalOpen, despesa, setDespesa, setRecurrenceModalOpen, setIsRecurring }: ModalRepetirProps) {
	const [warningMessage, setWarningMessage] = useState<string>('');
	const handleOk = () => {
		if (!despesa.recorrenciaDto?.qtdRepetir || !despesa.recorrenciaDto?.qtdFrequencia) {
			setWarningMessage('Preencha todos os campos');
			return;
		}
		setRecurrenceModalOpen(false);
		setWarningMessage('');
	};

	const handleCancel = () => {
		setDespesa({ ...despesa, recorrenciaDto: { qtdRepetir: 0, qtdFrequencia: undefined } });
		setWarningMessage('');
		setRecurrenceModalOpen(false);
		setIsRecurring(false);
	};

	return (
		<Modal title="Repetir Despesa" visible={isRecurrenceModalOpen} onCancel={handleCancel} onOk={handleOk} okText="Ok" cancelText="Cancelar">
			<Space direction="vertical" size="middle" style={{ width: '100%' }}>
				<Typography.Text>
					Configure quantas vezes deseja repetir a despesa e o intervalo entre as repetições.
					<Tooltip title="Aqui você define quantas vezes quer repetir a despesa e o intervalo (em dias, semanas, meses ou anos). Será criada uma nova despesa para cada repetição.">
						<QuestionCircleOutlined rev={undefined} style={{ marginLeft: 8 }} />
					</Tooltip>
				</Typography.Text>

				<Space direction="horizontal" style={{ justifyContent: 'space-around', width: '100%' }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						<BaseInput
							placeholder="0"
							labelConfig={{ label: 'Digite a quantidade de vezes' }}
							type="number"
							min={1}
							max={100}
							value={despesa?.recorrenciaDto?.qtdRepetir}
							onChange={(e) => setDespesa({ ...despesa, recorrenciaDto: { ...despesa?.recorrenciaDto, qtdRepetir: Number(e.target.value) } })}
						/>
					</div>

					<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						<BaseSelect
							placeholder="Selecione"
							value={despesa?.recorrenciaDto?.qtdFrequencia}
							onChange={(value) => setDespesa({ ...despesa, recorrenciaDto: { ...despesa?.recorrenciaDto, qtdFrequencia: value } })}
							style={{ width: 150 }}
							labelConfig={{ label: 'Selecione a frequência' }}
						>
							<Select.Option value="Dias">Dias</Select.Option>
							<Select.Option value="Semanas">Semanas</Select.Option>
							<Select.Option value="Meses">Meses</Select.Option>
							<Select.Option value="Anos">Anos</Select.Option>
						</BaseSelect>
					</div>
				</Space>
			</Space>
			<div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
				{warningMessage && <Typography.Text type="danger">{warningMessage}</Typography.Text>}
			</div>
		</Modal>
	);
}
